export default __webpack_public_path__ + "static/media/UserSideVideoMeetingLink.472e0507.mp3";